var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { isArray, isUndefined } from "../_utils/is.js";
const getValueData = (value, optionInfoMap) => {
  if (isUndefined(value)) {
    return void 0;
  }
  const optionInfo = optionInfoMap.get(value);
  if (!optionInfo) {
    return void 0;
  }
  return __spreadProps(__spreadValues({}, optionInfo), {
    label: optionInfo.label,
    closable: !optionInfo.disabled
  });
};
const getValueDataFromModelValue = (modelValue, optionInfoMap) => {
  if (isArray(modelValue)) {
    const result = [];
    for (const item of modelValue) {
      const valueData = getValueData(item, optionInfoMap);
      if (valueData) {
        result.push(valueData);
      }
    }
    return result;
  }
  return getValueData(modelValue, optionInfoMap);
};
export { getValueDataFromModelValue };
